import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  Radio,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Avatar,
  Grid,
} from "@mui/material";
import { blue, orange, brown, cyan, deepPurple } from "@mui/material/colors";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useSearchParams } from "react-router-dom";
import { getPositionLetter } from "../utils/positionUtils";
import { get } from "src/utils/networkUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";
import PlayerHeadshot from "src/components/PlayerHeadshot";

export default function PackPage() {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);
  const [cards, setCards] = useState([]);
  const [searchParams] = useSearchParams();
  const { isViewer } = getUserPermissions();


  useEffect(() => {
    if (searchParams.has("pack_id")) {
      let packId = searchParams.get("pack_id");
      get(`/admin/packs/${packId}/cards`).then(function (response) {
        setCards(response.cards);
        setLoading(false);
      });
    }
  }, [searchParams]);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  return (
    <>
      <Helmet>
        <title> Pack Details </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Pack Details
          </Typography>
        </Stack>

        <Card>
          {cards === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Rating</TableCell>
                      <TableCell>Avatar</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Position</TableCell>
                      <TableCell>Team</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cards.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.cardId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.cardRating === 2 && (
                            <Radio
                              checked={true}
                              value={2}
                              name="radio-buttons"
                              inputProps={{ "aria-label": "B" }}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 28,
                                },
                                color: orange[800],
                                "&.Mui-checked": {
                                  color: orange[600],
                                },
                              }}
                            />
                          )}

                          {row.cardRating === 1 && (
                            <Radio
                              checked={true}
                              value={1}
                              name="radio-buttons"
                              inputProps={{ "aria-label": "B" }}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 28,
                                },
                                color: cyan[800],
                                "&.Mui-checked": {
                                  color: cyan[600],
                                },
                              }}
                            />
                          )}
                          {row.cardRating === 0 && (
                            <Radio
                              checked={true}
                              value={0}
                              name="radio-buttons"
                              inputProps={{ "aria-label": "B" }}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 28,
                                },
                                color: brown[800],
                                "&.Mui-checked": {
                                  color: brown[600],
                                },
                              }}
                            />
                          )}
                          {row.cardRating === 3 && (
                            <Radio
                              checked={true}
                              value={3}
                              name="radio-buttons"
                              inputProps={{ "aria-label": "B" }}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 28,
                                },
                                color: blue[800],
                                "&.Mui-checked": {
                                  color: blue[600],
                                },
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                        <PlayerHeadshot row={row} />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.knownname}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Avatar sx={{ bgcolor: deepPurple[500] }}>
                            {getPositionLetter(row.position)}
                          </Avatar>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Grid container>
                            <Grid item xs={12} sx={{ textAlign: "left" }}>
                            {row.team}
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      {!isViewer && (
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              "& .MuiMenuItem-root": {
                px: 1,
                typography: "body2",
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem sx={{ color: "error.main" }}>
            <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
            Delete
          </MenuItem>
        </Popover>
      )}
    </>
  );
}
